<div class="grid-container">
  <div class="outer"></div>

  <div class="main-content border-shadow">
    <p>{{ errorPageLanguage.genericMessage | translate }}</p>
  </div>

  <div class="outer"></div>
</div>
